import React from 'react'
import clsx from 'clsx'
import { useLocation } from 'react-router'
import { useLayout } from '../../../core'
import { WithChildren } from '../../../../helpers/react18MigrationHelpers'
import { KTIcon } from '../../../../helpers/components/KTIcon'
import { checkIsActive } from '../../../../helpers/RouteHelpers'
import Box from '../../../../../components/Box'

type Props = {
    to?: string
    title: string
    icon?: string
    fontIcon?: string
    hasBullet?: boolean
    faIcon?: string
    isCustomActive: boolean
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
    children,
    to,
    title,
    icon,
    fontIcon,
    hasBullet,
    faIcon,
    isCustomActive
}) => {
    const { pathname } = useLocation()
    const isActive = isCustomActive ? true : to ? checkIsActive(pathname, to) : undefined;
    const { config } = useLayout()
    const { app } = config

    return (
        <div
            className={clsx('menu-item', { 'here show': isActive }, 'menu-accordion')}
            data-kt-menu-trigger='click'
        >
            <span className='menu-link'>
                {hasBullet && (
                    <span className='menu-bullet'>
                        <span className='bullet bullet-dot'></span>
                    </span>
                )}
                {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
                    <span className='menu-icon'>
                        <KTIcon iconName={icon} className='fs-2' />
                    </span>
                )}
                {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
                    <i className={clsx('bi fs-3', fontIcon)}></i>
                )}

                {
                    faIcon && (
                        <Box width='19px' height='19px' mr='7.5px' justifyContent='center' alignItems='center'>
                            <i className={'fs-4 fa ' + faIcon}></i>
                        </Box>
                    )
                }
                <span className='menu-title'>{title}</span>
                <span className='menu-arrow'></span>
            </span>
            <div className={clsx('menu-sub menu-sub-accordion', { 'menu-active-bg': isActive })}>
                {children}
            </div>
        </div >
    )
}

export { SidebarMenuItemWithSub }
